var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { TRPCClientError } from '@trpc/client';
import { observable } from '@trpc/server/observable';
import { demoData } from '@web/lib/demo/demoData';
import { endOfDay, startOfDay } from 'date-fns';
export var mockLink = function () {
    return function () {
        return function (_a) {
            var op = _a.op;
            return observable(function (observer) {
                var _a;
                var type = op.type, path = op.path, input = op.input;
                if (type === 'query' && path in demoData) {
                    var dataHandler = demoData[path];
                    if (!dataHandler) {
                        observer.error(new TRPCClientError("Mock data not found for path: ".concat(path)));
                        return;
                    }
                    try {
                        var inputData = (_a = input) !== null && _a !== void 0 ? _a : {};
                        var processedInput = __assign(__assign({}, inputData), { dateFrom: inputData.dateFrom
                                ? startOfDay(new Date(inputData.dateFrom))
                                : inputData.dateFrom, dateTo: inputData.dateTo
                                ? endOfDay(new Date(inputData.dateTo))
                                : inputData.dateTo });
                        var result = dataHandler(processedInput);
                        observer.next({
                            result: { data: result }
                        });
                        observer.complete();
                    }
                    catch (error) {
                        observer.error(new TRPCClientError("Error executing mock data handler for path: ".concat(path)));
                    }
                }
                else {
                    observer.error(new TRPCClientError("Unsupported operation type or path: ".concat(path)));
                }
            });
        };
    };
};
